import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import Select from '@/components/ui/Select/Select';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const PROVINCE_NAME = 'accident_province_id';

export const PROVINCE = {
  DOLNOSLASKIE: 'PROVINCE_DOLNOSLASKIE',
  KUJAWSKO_POMORSKIE: 'PROVINCE_KUJAWSKO_POMORSKIE',
  LUBELSKIE: 'PROVINCE_LUBELSKIE',
  LUBUSKIE: 'PROVINCE_LUBUSKIE',
  LODZKIE: 'PROVINCE_LODZKIE',
  MALOPOLSKIE: 'PROVINCE_MALOPOLSKIE',
  MAZOWIECKIE: 'PROVINCE_MAZOWIECKIE',
  OPOLSKIE: 'PROVINCE_OPOLSKIE',
  PODKARPACKIE: 'PROVINCE_PODKARPACKIE',
  PODLASKIE: 'PROVINCE_PODLASKIE',
  POMORSKIE: 'PROVINCE_POMORSKIE',
  SLASKIE: 'PROVINCE_SLASKIE',
  SWIETOKRZYSKIE: 'PROVINCE_SWIETOKRZYSKIE',
  WARMINSKO_MAZURSKIE: 'PROVINCE_WARMINSKO_MAZURSKIE',
  WIELKOPOLSKIE: 'PROVINCE_WIELKOPOLSKIE',
  ZACHODNIOPOMORSKIE: 'PROVINCE_ZACHODNIOPOMORSKIE',
} as const;

export const SelectAccidentProvince = () => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={PROVINCE_NAME}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('W jakim województwie miało miejsce zdarzenie?')}
          </FormLabel>
          <FormControl>
            <Select
              {...field}
              placeholder={i18n.t('Wybierz województwo')}
              success={fieldState.isDirty && !fieldState.error && field.value}
              options={[
                { label: i18n.t('dolnośląskie'), value: PROVINCE.DOLNOSLASKIE },
                {
                  label: i18n.t('kujawsko-pomorskie'),
                  value: PROVINCE.KUJAWSKO_POMORSKIE,
                },
                { label: i18n.t('lubelskie'), value: PROVINCE.LUBELSKIE },
                { label: i18n.t('lubuskie'), value: PROVINCE.LUBUSKIE },
                { label: i18n.t('łódzkie'), value: PROVINCE.LODZKIE },
                { label: i18n.t('małopolskie'), value: PROVINCE.MALOPOLSKIE },
                { label: i18n.t('mazowieckie'), value: PROVINCE.MAZOWIECKIE },
                { label: i18n.t('opolskie'), value: PROVINCE.OPOLSKIE },
                { label: i18n.t('podkarpackie'), value: PROVINCE.PODKARPACKIE },
                { label: i18n.t('podlaskie'), value: PROVINCE.PODLASKIE },
                { label: i18n.t('pomorskie'), value: PROVINCE.POMORSKIE },
                { label: i18n.t('śląskie'), value: PROVINCE.SLASKIE },
                {
                  label: i18n.t('świętokrzyskie'),
                  value: PROVINCE.SWIETOKRZYSKIE,
                },
                {
                  label: i18n.t('warmińsko-mazurskie'),
                  value: PROVINCE.WARMINSKO_MAZURSKIE,
                },
                {
                  label: i18n.t('wielkopolskie'),
                  value: PROVINCE.WIELKOPOLSKIE,
                },
                {
                  label: i18n.t('zachodniopomorskie'),
                  value: PROVINCE.ZACHODNIOPOMORSKIE,
                },
              ]}
              data-testid="select-accident-province"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
